export const Role = {
    SuperAdmin: 'SuperAdmin',
    Admin: 'Admin',
    Standard: 'Standard'
}